import React from 'react';
import Button from '@fff-web/fff-ui-shared/Button';
import styles from './ProRatedUpgrade.module.scss';
import HeroBanner from './components/HeroBanner/HeroBanner';
import UpgradeDisclaimer from './components/UpgradeDisclaimer/UpgradeDisclaimer';
import { AnnualMemberContainer } from './components/AnnualMemberContainer/AnnualMemberContainer';
import { CurrentPlanCard } from './components/CurrentPlanCard/CurrentPlanCard';
import { PRO_RATED_UPGRADE_MESSAGES } from './ProRatedUpgradeUtils';

interface ProRatedUpgradeProps {
  annualPrice: number;
  seasonalPrice: number;
  submitUpgrade: () => void;
  scrollToRef?: React.MutableRefObject<HTMLDivElement>;
  loading: boolean;
}

const ProRatedUpgrade = ({
  annualPrice,
  seasonalPrice,
  submitUpgrade,
  scrollToRef,
  loading,
}: ProRatedUpgradeProps) => {
  return (
    <main ref={scrollToRef} className={styles.wrapper}>
      <HeroBanner />
      <div className={styles.contentWrapper}>
        <AnnualMemberContainer annualPrice={annualPrice} />
        <CurrentPlanCard seasonalPrice={seasonalPrice} />
        <UpgradeDisclaimer />
      </div>
      <section className={styles.buttonsContainer}>
        <Button
          data-testid={PRO_RATED_UPGRADE_MESSAGES.proRatedUpgradeId}
          disabled={loading}
          onClick={submitUpgrade}
        >
          {PRO_RATED_UPGRADE_MESSAGES.ctaName}
        </Button>
      </section>
    </main>
  );
};

export { ProRatedUpgrade };
export type { ProRatedUpgradeProps };
